var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartSlateBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0076 22C13.811 22 16.3724 20.9458 18.3179 19.2137L10.5518 11.4462C10.431 11.3253 10.363 11.1613 10.363 10.9904V0C4.59232 0.334975 0 5.13602 0 10.9903C0 17.0611 4.93802 22 11.0076 22Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 11.6406L19.2283 18.3077C20.8263 16.512 21.8466 14.1916 21.9946 11.6406H12.5625Z",
    fill: "#2C3E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 10.3456H21.9921C21.6695 4.78721 17.2057 0.322597 11.6484 0V10.3456Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartSlateBlue);
export default __webpack_public_path__ + "static/media/pie-chart-slate-blue.de70f5ad7dee1f771dae8c88a7bbdb53.svg";
export { ForwardRef as ReactComponent };